window.app.controller('udostepnijCtrl', ['$scope', '$http', function ($scope, $http) {

  $scope.offersShow = true;

  $scope.discounts = [];
  $scope.filters = [];
  $scope.filterControls = document.querySelectorAll('input');
  $scope.filterChecked = false;

  $scope.setUpFilters = function () {
    $scope.filters.splice(0);
    //empty array of discounts

    $scope.filterControls.forEach(item => {
      if (item.checked) {
        $scope.filters.push(item.value);
      }
      //if checkbox - checked - push it to array - filters
    });
    let filter = '&filters=' + $scope.filters.join(';');
    //rewrite url - for each chosen filters

    $scope.sendXHR({
      url: `/api/front/offer/rabaty?${filter}`,
      data: '',
      method: 'GET',
      headers: {'Content-Type': 'application/json'},
      dataAsParam: false,
      successFunc: function success(resp) {
        $scope.discounts = resp.data;
        }
    });
  };
  //send request for each chosen filters, rewrite them to our array discounts

  $("input").on("click", function(){
    $(this).parent().toggleClass("isSelected");
  });
  //when checkbox checked - change class

}])



// WEBPACK FOOTER //
// src/js/controllers/udostepnij/udostepnijCtrl.js